import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';

// Import pages
import LoginPage from './pages/LoginPage';
import FeedbackFormPage from './pages/FeedbackFormPage';
import DashboardPage from './pages/DashboardPage';
import FeedbackListPage from './pages/FeedbackListPage';
import QRCodePage from './pages/QRCodePage';
import AdminPage from './pages/AdminPage';
import UserManagementPage from './pages/UserManagementPage';

// Import global CSS
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<FeedbackFormPage />} />
              <Route path="/feedback-form" element={<FeedbackFormPage />} />
              <Route path="/login" element={<LoginPage />} />
              
              {/* Protected routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              
              <Route path="/feedback-list" element={
                <ProtectedRoute>
                  <FeedbackListPage />
                </ProtectedRoute>
              } />
              
              {/* Admin routes */}
              <Route path="/admin" element={
                <ProtectedRoute roles={['Admin', 'SuperAdmin']}>
                  <AdminPage />
                </ProtectedRoute>
              } />
              
              {/* SuperAdmin routes */}
              <Route path="/qr-codes" element={
                <ProtectedRoute roles={['SuperAdmin']}>
                  <QRCodePage />
                </ProtectedRoute>
              } />
              
              <Route path="/user-management" element={
                <ProtectedRoute roles={['SuperAdmin']}>
                  <UserManagementPage />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;